export const DEFAULT_PAGE_SIZE = 20
export const TOTAL_PAGES_TO_SHOW = 10
export const CUSTOMER_AREA = 'https://www.naturgy.es/hogar/ayuda/tu_area_clientes'
export const CUSTOMER_SERVICE_ES = 'https://www.naturgy.es/hogar/ayuda/contacto'
export const CUSTOMER_SERVICE_CT = 'https://www.naturgy.es/ca/llar/ajuda/contacte'
export const CUSTOMER_SERVICE_GL = 'https://www.naturgy.es/gl/fogar/axuda/contacto'
